import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=3652680d&"
import script from "./rich-editor.vue?vue&type=script&lang=ts&"
export * from "./rich-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports